import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import logo from '../images/logo.png';
import { CrackersContext } from "../CrackersContext";
import TextInput from "./TextInput";
import { isValidEmail, isValidPassword } from "../CrackersUtil";
import { raisePostRequest } from "../AxiosAPI";
import { useLocation, useNavigate } from "react-router-dom";

function PasswordReset() {
    const {setShowErrorToastStatus, setToastBody, setIsZeroCasePage } = useContext(CrackersContext);
    const captionEmail = 'Confirm your Email to reset password', captionNewPassword = "Enter your new password", captionConfirmPassword = "Gives once again same password";
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [cPassword, setCPassword] = useState('');
    const [emailValidation, setEmailValidation] = useState({});
    const [passwordValidation, setPasswordValidation] = useState({});
    const [cpasswordValidation, setCpasswordValidation] = useState({});
    const [digest, setDigest] = useState("");
    const [isValidLink, setIsValidLink] = useState(false);
    const [isValidDigest, setIsValidDigest] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setIsZeroCasePage(true);

        const params = new URLSearchParams(location.search);
        var digest = "";
        for (const [key, value] of params.entries()) {
            if(key === 'digest') {
                digest = value;
                setDigest(digest);
                break;
            }
        }

        const isValidDigest = async (digest) => {
            const resposne = await raisePostRequest("/customer/validate-pw-reset", {"digest" : digest}, null, null, null);
            if(resposne.status === 'success') {
                setIsValidDigest(true);
            }
        }
        isValidDigest(digest);

    }, []);

    const validateEmail = async (email) => {
        const error = {};
        var response = isValidEmail(email);
        if(response) {
            setEmailValidation({ "validation": true});
            return true;
        } else {
            error.validation = false;
            error.reason = "Invalid Email";
            setEmailValidation(error);
            return false;
        }
    };

    const userNamecheck = async() => {
        const staus = await raisePostRequest(`/customer/user-name-check`, {"user_name" : email}, null, setShowErrorToastStatus, setToastBody);
        if(!staus.user_exist) {
            setEmailValidation({"reason" : "This account is not registered with us. If you don't have an account, kindly sign up with us.", "validation" : false});
            return false;
        }
        return true;
    };

    const validatePassword = () => {
        const errors = {};
        if (!password) {
            errors.validation = false;
            errors.reason = "Password is required";
            setPasswordValidation(errors);
            return false;
        }

        const status = isValidPassword(password);
        if(status === 'success') {
            setPasswordValidation({"validation" : true});
            return true;
        } else {
            setPasswordValidation({"validation" : false, "reason" : status});
            return false;
        }
    }

    const validateCPassword = () => {
        const errors = {};
        if (!cPassword) {
            errors.validation = false;
            errors.reason = "Please confirm password again";
            setCpasswordValidation(errors);
            return false;
        } else if (password !== cPassword) {
            errors.validation = false;
            errors.reason = "Password and confirm password are mismatched";
            setCpasswordValidation(errors);
            return false;
        } else {
            errors.validation = true;
            setCpasswordValidation(errors);
            return true;
        }
    }

    const validateLink = async () => {
        const resposne = await raisePostRequest("/customer/validate-pw-reset", {"digest" : digest, "email_id" : email}, null, setShowErrorToastStatus, setToastBody);
        if(resposne.status === 'success') {
            setIsValidLink(true);
        }
    }

    const changePassword = async () => {
        const validation = emailValidation.validation && passwordValidation.validation && cpasswordValidation.validation;
        if(validation) {
            const resposne = await raisePostRequest("/customer/reset-pw", {"digest" : digest, "email_id" : email, "passowrd" : password, "c_password" : cPassword}, null, setShowErrorToastStatus, setToastBody);
            if(resposne.status === 'success') {
                navigate(`/web/signin`);
            }
        }
    }

    return (
        <>
            <div style={{marginTop : "2%"}} hidden={!isValidDigest}>
                <Row>
                    <Col md={3}></Col>
                    <Col md={6}>
                        <div style={{background : "white", padding : "2% 2% 2% 2%", borderRadius : "10px"}}>
                            <Row>
                                <Col md={3}>
                                    <h3 style={{color : "#FF5C00"}}><img src={logo} alt="Logo" style={{height : "35px", marginRight : "-18px"}} />rackleCart</h3>
                                </Col>    
                            </Row>

                            <Row style={{marginTop : "2%"}}>
                                <Col md={6}>
                                    <h5 style={{fontWeight : "bold"}}>Verify Your Email to Continue</h5>
                                    <p>For your account’s security, please confirm your registered email address before creating a new password.</p>
                                    <p><b>🔒 Why this step?</b> This extra verification ensures that only the rightful account owner can change the password, even if someone else gains access to the link.</p>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={5}>
                                    <Row>
                                        <TextInput caption={captionEmail}
                                                    value={email}
                                                    onChange={setEmail}
                                                    validation={emailValidation}
                                                    info={"We'll never share your Email to reset password"}
                                                    onFocusCaption={"Email"}
                                                    validator={validateEmail}
                                                    isMultiLine={false} 
                                                    readOnly={isValidLink}/>
                                    </Row>
                                    <Row className="d-flex justify-content-end">
                                        <Col xs={6}></Col>
                                        <Col xs={6}>
                                            <Button onClick={validateLink}>Continue</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={3}></Col>
                </Row>

                <div style={{marginTop : "2%"}} hidden={!isValidLink}>
                    <Row>
                        <Col md={3}></Col>
                        <Col md={6}>
                            <div style={{background : "white", padding : "2% 2% 2% 2%", borderRadius : "10px"}}>
                                <Row style={{marginTop : "2%"}}>
                                    <Col md={6}>
                                        <h5 style={{fontWeight : "bold"}}>Create Your New Password</h5>
                                        <p>You’re just one step away from regaining access to your account. Please enter and confirm your new password below.</p>
                                        <ul>
                                            <li>
                                                <p>Password must be between 8 and 16 characters long.</p>
                                            </li>
                                            <li>
                                                <p>Contains at least one uppercase letter, one lowercase letter, and one number</p>
                                            </li>
                                            <li>
                                                <p>Avoid using old passwords for better security</p>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col md={1}></Col>
                                    <Col md={5}>
                                        <Row>
                                            <TextInput caption={captionNewPassword}
                                                        value={password}
                                                        onChange={setPassword}
                                                        validation={passwordValidation}
                                                        info={"Password must be 8–16 characters and can include A–Z, a–z, 0–9, and ! @ # $ % ^ & * _ + - = ?"}
                                                        onFocusCaption={"New password"}
                                                        validator={validatePassword}
                                                        isMultiLine={false}
                                                        isPasswordField={true}
                                                        type={"password"} />
                                        </Row>
                                        <Row>
                                            <TextInput caption={captionConfirmPassword}
                                                        value={cPassword}
                                                        onChange={setCPassword}
                                                        validation={cpasswordValidation}
                                                        info={""}
                                                        onFocusCaption={"Connfirm password"}
                                                        validator={validateCPassword}
                                                        isMultiLine={false}
                                                        isPasswordField={true}
                                                        type={"password"} />
                                        </Row>
                                        <Row className="d-flex justify-content-end">
                                            <Col xs={6}></Col>
                                            <Col xs={6}>
                                                <Button onClick={changePassword}>Save New Passowrd</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={3}></Col>
                    </Row>
                </div>
            </div>

            <div style={{marginTop : "2%"}} hidden={isValidDigest}>
                <Row>
                    <Col md={3}></Col>
                    <Col md={6}>
                        <div style={{background : "white", padding : "2% 2% 2% 2%", borderRadius : "10px"}}>
                            <Row>
                                <Col md={3}>
                                    <h3 style={{color : "#FF5C00"}}><img src={logo} alt="Logo" style={{height : "35px", marginRight : "-18px"}} />rackleCart</h3>
                                </Col>    
                            </Row>

                            <Row style={{marginTop : "2%"}}>
                                <Col xs={12}>
                                    <h4 style={{fontWeight : "bold"}}>Link expired</h4>
                                    <p>That reset link has expired. Please request a new password reset.</p>
                                    
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={3}></Col>
                </Row>

                <div style={{marginTop : "2%"}} hidden={!isValidLink}>
                    <Row>
                        <Col md={3}></Col>
                        <Col md={6}>
                            <div style={{background : "white", padding : "2% 2% 2% 2%", borderRadius : "10px"}}>
                                <Row style={{marginTop : "2%"}}>
                                    <Col md={6}>
                                        <h5 style={{fontWeight : "bold"}}>Create Your New Password</h5>
                                        <p>You’re just one step away from regaining access to your account. Please enter and confirm your new password below.</p>
                                        <ul>
                                            <li>
                                                <p>Password must be between 8 and 16 characters long.</p>
                                            </li>
                                            <li>
                                                <p>Contains at least one uppercase letter, one lowercase letter, and one number</p>
                                            </li>
                                            <li>
                                                <p>Avoid using old passwords for better security</p>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col md={1}></Col>
                                    <Col md={5}>
                                        <Row>
                                            <TextInput caption={captionNewPassword}
                                                        value={password}
                                                        onChange={setPassword}
                                                        validation={passwordValidation}
                                                        info={"Password must be 8–16 characters and can include A–Z, a–z, 0–9, and ! @ # $ % ^ & * _ + - = ?"}
                                                        onFocusCaption={"New password"}
                                                        validator={validatePassword}
                                                        isMultiLine={false}
                                                        isPasswordField={true}
                                                        type={"password"} />
                                        </Row>
                                        <Row>
                                            <TextInput caption={captionConfirmPassword}
                                                        value={cPassword}
                                                        onChange={setCPassword}
                                                        validation={cpasswordValidation}
                                                        info={""}
                                                        onFocusCaption={"Connfirm password"}
                                                        validator={validateCPassword}
                                                        isMultiLine={false}
                                                        isPasswordField={true}
                                                        type={"password"} />
                                        </Row>
                                        <Row className="d-flex justify-content-end">
                                            <Col xs={6}></Col>
                                            <Col xs={6}>
                                                <Button>Save New Passowrd</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={3}></Col>
                    </Row>
                </div>
            </div>
        </>
        
    );

}

export default PasswordReset;